module.exports = __webpack_public_path__ + "static/avatar_anatoliy_rudenko-b7a4efe1abd571bab15ee64d7585365c.jpg";